import { add, listen, qs, remove } from '@fluorescent/dom';

import { section } from '@/neon';

section('video', {
  onLoad() {
    const { videoId, videoType } = this.container.dataset;

    if (!videoId || !videoType) return;

    const player = qs('[data-video-player]', this.container);
    const button = qs('[data-play-button]', this.container);
    const overlay = qs('[data-overlay]', this.container);
    const image = qs('.video__image', this.container);
    
    const firstPlayClick = () => {
      import('@fluorescent/video').then(({ default: Video }) => {
        console.log("FPC", this.video)
        if (this.video) {
          return;
        }
        this.video = Video(this.container, {
          id: videoId,
          type: videoType,
          playerEl: player,
        });
  
        this.video.on('play', () => {
          const iframe = qs('iframe', this.container);
          iframe.taxindex = 0;
          iframe.focus();
  
          remove(overlay, 'visible');
          image && remove(image, 'visible');
        });
  
        this.video.on('pause', () => {
          const iframe = qs('iframe', this.container);
          iframe.tabindex = -1;
  
          add(overlay, 'visible');
          image && add(image, 'visible');
  
          button.focus();
        });
  
        this.buttonClick = listen(button, 'click', () => {
          this.video.play();
        });
  
        this.video.play();
      });
    };

    this.firstPlayHandler = listen(button, 'click', firstPlayClick);
  },

  onUnload() {
    this.video && this.video.destroy();
    this.buttonClick();
    this.firstPlayHandler();
  },
});
